<ng-content></ng-content>

<div class="spacer" *ngIf="!disableSpacer"></div>
